module.exports = __webpack_public_path__ + "img/process-icon-4.79be3b71.svg";